import * as api from '../api';

export function makeDeposit(body) {
  return api.post('v3/deposit', body);
}

export function getDeposits(params) {
  return api.get('deposit/', params);
}
